const uuid = require('uuid');

export function generateUUID(){
    let id = uuid.v4();
    let splitUUID = id.split('-');
    return splitUUID[splitUUID.length-1];
}